import { BrowserDetection } from '@inter-ikea-kompis/browser-support';
export default class SummaryPageBrowserUtility {
    static isSafari14OrOlder() {
        const browser = BrowserDetection.getBrowser();
        if (browser?.name?.toLowerCase() !== 'safari') {
            return false;
        }
        const major = browser?.version?.split('.')?.[0];
        if (!major) {
            return false;
        }
        return parseInt(major) <= 14;
    }
    static isSafari() {
        const browser = BrowserDetection.getBrowser();
        return browser?.name?.toLowerCase() === 'safari';
    }
}
//# sourceMappingURL=SummaryPageBrowserUtility.js.map